import React from 'react';
import { Modal, Button } from "react-bootstrap";
import { AiOutlineClose } from "react-icons/ai";

import './videoModal.module.css';

const VideoModal = (props) => {

    return(
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="video-modal"
            styleName="video-modal"
        >
            {/* <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                Modal heading
                </Modal.Title>
            </Modal.Header> */}
            <Modal.Body styleName="video-modal-body">
                <Button styleName="vid-modal-close-btn" onClick={props.onHide} variant="danger"><AiOutlineClose /></Button>
            <iframe
                style={{ width:'100%', height:'85vh' }}
                src={"https://www.youtube.com/embed/"+ props.videoId +"?autoplay=1"}
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            >

            </iframe>
            </Modal.Body>
            {/* <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer> */}
        </Modal>
    )
}

export default VideoModal;